<template>
  <div>
    <el-drawer v-loading="loading" :title="form.id ? (type == '查看' ? '查看拜访记录' : '编辑拜访记录') : '新增拜访记录'" :visible.sync="show" size="95%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看' || isRejectTo " :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="拜访记录单号" prop="sn">
                <el-input v-model="form.sn" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="拜访对象名称" prop="callOnObjectName">
                <el-input v-model="form.callOnObjectName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="拜访日期" prop="callOnTime">
                <el-date-picker v-model="form.callOnTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择拜访日期" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createUser">
                <el-input v-model="form.createUser" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createTime">
                <el-input v-model="form.createTime" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单状态" prop="status">
                <el-input v-model="statusArr[form.status]" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="拜访人员" prop="callOnPersonnel">
                <el-input v-model="form.callOnPersonnel" :autosize="true" type="textarea" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="拜访信息">
          <el-row>
            <el-form-item label="调研与反馈内容" prop="callOnNote">
              <el-input v-model="form.callOnNote" :autosize="{ minRows: 10 }" type="textarea" />
            </el-form-item>
          </el-row>
        </el-card>
        <el-card header="附件信息">
          <el-row>
            <FileUpload :value.sync="form.crmCallOnRecordAccessoryModels" :file-type="fileUploadType" :show-delect="form.status<=1 || !form.status" :file-size="5" />
          </el-row>
        </el-card>

        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable" style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="'flowPathNodePersonModels.' + scope.$index + '.nodePerson'" :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search" @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId" @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary" @click="saveAndSubmit()">提交审核</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%" :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300" @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current" :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload/index'
import Pagination from '@/components/Pagination'
// import { getPage as getSalesOrganization } from '@/api/crm/base/salesOrganization'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'

import { getByGeneralManager } from '@/api/crm/base/audit'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'

import {
  get,
  saveOrUpdate,
  submit
} from '@/api/crm/customer/customerVisitRecord'

export default {
  name: 'CustomerVisitRecordEdit',
  components: {
    FileUpload,
    Flow,
    Pagination
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      statusArr: ['', '制单', '审核中', '审核完成'],
      flowPathOptions: [],
      format: format,
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        flowPathNodePersonModels: [],
        flowPathTemplateId: null,
        roleId: null
      },
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      rules: {
        callOnObjectName: [
          { required: true, message: '拜访对象名称不能为空', trigger: 'blur' }
        ],
        callOnTime: [
          { required: true, message: '拜访日期不能为空', trigger: 'change' }
        ],
        callOnPersonnel: [
          { required: true, message: '拜访人员不能为空', trigger: 'blur' }
        ],
        callOnNote: [
          { required: true, message: '调研与反馈内容不能为空', trigger: 'blur' }
        ]
      },
      showObj: {
        nodePerson: false
      },
      loadingObj: {
        nodePerson: false
      },
      // 分页
      pagination: {
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        nodePerson: []
      },
      condition: {

        nodePerson: {}
      },
      selection: {
        nodePerson: []
      },
      nodePersonIndex: null,
      isRejectTo: false,
      roleId: null,
      fileUploadType: ['png', 'jpg', 'jpeg', 'pdf', 'mp4', 'avi', 'mov', '3gp', 'docx', 'xlsx', 'xls', 'doc']
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }

      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    }
  },
  methods: {

    init() {
      getByPathTemplate({ templateType: '客户拜访记录' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId

      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    // 选择审批人

    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },

    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId

        this.flowRejectTo(null, null)
        this.loading = false
        this.$nextTick(() => {
          // this.$refs.elTable.doLayout()
        })
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true
            const formData = JSON.parse(JSON.stringify(this.form))

            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            // this.form.id = this.form.id || data
            this.editId = this.form.id || data

            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    flowRejectTo(isAssignee, nodeName) {
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    async submit() {
      try {
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        // this.handleClose()
        this.getData()
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    }

  }
}
</script>
<style scoped>
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
.dialog >>> .el-dialog__body {
  overflow: hidden !important;
}
.footer-box {
  margin-top: 10px;
}
</style>
